var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowersellerRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1H10C5.02944 1 1 5.02944 1 10V15C1 17.2091 2.79086 19 5 19H12C16.9706 19 21 14.9706 21 10C21 5.02944 16.9706 1 12 1Z",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2651 7.91679L11 8.18195L10.7348 7.91679C10.0026 7.18456 8.81538 7.18456 8.08315 7.91679C7.35092 8.64902 7.35092 9.83621 8.08315 10.5684L9.93931 12.4246C10.5251 13.0104 11.4748 13.0104 12.0606 12.4246L13.9168 10.5684C14.649 9.83621 14.649 8.64902 13.9168 7.91679C13.1845 7.18456 11.9974 7.18456 11.2651 7.91679Z",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowersellerRequest);
export default __webpack_public_path__ + "static/media/powerseller-request.7abb88b28fac0236751083fd148f13ca.svg";
export { ForwardRef as ReactComponent };